import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	icon: {
		float: 'left',
		cursor: 'pointer',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.05)'
		},
		'&:active': {
			transform: 'scale(.8)'
		}
	},
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main,
		padding: '0',
		textAlign: 'left'
	}
}));
